import React from "react";
import PropTypes from "prop-types";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import { withStyles } from "tss-react/mui";

class Limit extends React.Component {
  handleChange = (event) => {
    if (this.props.onChange) {
      this.props.onChange(event.target.value);
    }
  };

  render() {
    const { classes, values, prefix, suffix } = this.props;

    return (
      <FormControl className={classes.selectFormControl} fullWidth>
        <InputLabel className={classes.selectLabel} htmlFor={"simple-select"}>
          Items
        </InputLabel>
        <Select
          MenuProps={{
            className: classes.selectMenu,
          }}
          classes={{
            select: classes.select,
          }}
          inputProps={{
            name: "per_page",
            id: "simple-select",
          }}
          onChange={this.handleChange}
          value={this.props.selected}
        >
          {values.map((item, key) => {
            return (
              <MenuItem
                classes={{
                  root: classes.selectMenuItem,
                  selected: classes.selectMenuItemSelected,
                }}
                key={key}
                value={item}
              >
                {prefix}
                {item}
                {suffix}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    );
  }
}

Limit.defaultProps = {
  values: [10, 25, 50, 100, 250, 1000],
  prefix: "",
  suffix: " Records",
};

Limit.propTypes = {
  values: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.any.isRequired,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
};

export default withStyles(Limit, {});
